import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevelaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45875_66632)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 40,
				rx: 8,
				fill: "#FF7804"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
				fill: "#FF7804"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.8003 11.0303C16.3019 10.9971 16.9552 11.0181 17.4717 11.0201L20.1746 11.0232L28.9365 11.0261C28.8812 15.4237 28.9347 19.8999 28.9225 24.3062C28.612 24.6337 28.2695 24.9332 27.9532 25.2516C27.6102 25.5968 27.2708 25.956 26.932 26.3065C26.4331 26.8239 25.9302 27.3374 25.4231 27.8469C25.2181 28.0569 24.4452 28.9173 24.2002 28.968C19.8384 29.0242 15.4422 28.9381 11.0729 28.9894C11.0876 28.3367 11.0679 27.6022 11.0661 26.943L11.0635 23.0837C11.063 20.6766 11.1055 18.166 11.0669 15.7734C11.243 15.5319 12.2281 14.5809 12.4964 14.308C13.1413 13.6479 13.7906 12.9921 14.444 12.3405C14.7774 12.0019 15.427 11.2594 15.8003 11.0303Z",
				fill: "#FEFEFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.4438 13.3745C20.4649 13.3888 23.6186 13.3233 26.623 13.3897L26.6195 16.9013C26.6198 17.2329 26.64 18.3265 26.594 18.5899L26.5894 18.6153C26.5009 19.1194 25.4618 19.8183 25.08 20.4359C25.0528 21.0655 25.0764 21.7074 25.0702 22.3379C25.0669 22.6816 25.086 23.0538 25.0373 23.3925C24.6179 23.9223 23.9454 24.5468 23.4501 25.0437C23.026 25.4691 22.4004 26.1951 21.9797 26.5482C21.919 24.8504 21.9673 22.8802 21.9634 21.1597C21.2618 21.1544 20.5602 21.1528 19.8586 21.1549C18.2533 21.1534 16.6164 21.1773 15.0167 21.1592C15.1709 20.91 17.8718 18.2012 18.1099 18.0623C18.6486 18.0353 19.3657 18.0553 19.9149 18.0551L23.5066 18.0633C23.5014 17.546 23.5016 17.0286 23.5072 16.5113C22.2074 16.4777 20.8335 16.4986 19.528 16.4988L13.6816 16.4824C13.9811 16.1074 14.6358 15.5064 14.992 15.1631C15.4757 14.6967 16.3091 13.7581 16.8118 13.395C17.0087 13.3782 17.2432 13.3785 17.4438 13.3745Z",
				fill: "#FF7804"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45875_66632",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 8,
			fill: "white"
		})
	}) })]
});
export default SvgRevelaLogo;
